export enum Projects {
  ZEUS = 'zeus',
  APOLLO = 'apollo',
  WINCANTON = 'wincanton',
  IPL = 'ipl',
}
